import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import SEO from "../../utils/seo";
import Button from "../../components/base/Button";
import { Helmet } from "react-helmet";

const ServiceAreas = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Mobile Car Detailing Service Areas Melbourne",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Starlight Motors Mobile Detailing",
      "telephone": "0491121950"
    },
    "areaServed": [
      { "@type": "City", "name": "Hillside, VIC" },
      { "@type": "City", "name": "Taylors Hill, VIC" },
      { "@type": "City", "name": "Sydenham, VIC" },
      { "@type": "City", "name": "Caroline Springs, VIC" },
      { "@type": "City", "name": "Taylors Lakes, VIC" },
      { "@type": "City", "name": "Delahey, VIC" },
      { "@type": "City", "name": "Keilor Downs, VIC" },
      { "@type": "City", "name": "Keilor, VIC" },
      { "@type": "City", "name": "Burnside, VIC" },
      { "@type": "City", "name": "Burnside Heights, VIC" },
      { "@type": "City", "name": "St Albans, VIC" },
      { "@type": "City", "name": "Kings Park, VIC" },
      { "@type": "City", "name": "Kealba, VIC" },
      { "@type": "City", "name": "Albion, VIC" }
    ]
  };

  const serviceAreas = [
    {
      name: "Hillside",
      description: "Professional mobile car detailing services in Hillside. We bring showroom-quality detailing to your driveway.",
      link: "/service-areas/hillside"
    },
    {
      name: "Taylors Hill",
      description: "Expert car detailing in Taylors Hill. Full interior & exterior detailing, ceramic coating, and more.",
      link: "/service-areas/taylors-hill"
    },
    {
      name: "Sydenham",
      description: "Premium mobile detailing in Sydenham. Professional service delivered to your location.",
      link: "/service-areas/sydenham"
    },
    {
      name: "Caroline Springs",
      description: "Top-rated car detailing in Caroline Springs. Ceramic coating, paint correction, and full detailing packages.",
      link: "/service-areas/caroline-springs"
    },
    {
      name: "Taylors Lakes",
      description: "Mobile car detailing specialists in Taylors Lakes. We come to you with professional equipment.",
      link: "/service-areas/taylors-lakes"
    },
    {
      name: "Delahey",
      description: "Quality car detailing services in Delahey. Interior, exterior, and ceramic coating specialists.",
      link: "/service-areas/delahey"
    },
    {
      name: "Keilor Downs",
      description: "Professional mobile detailing in Keilor Downs. Full-service car care at your doorstep.",
      link: "/service-areas/keilor-downs"
    },
    {
      name: "Keilor",
      description: "Expert car detailing in Keilor. Premium mobile service with guaranteed satisfaction.",
      link: "/service-areas/keilor"
    },
    {
      name: "Burnside",
      description: "Mobile car detailing in Burnside. Professional results without leaving your home.",
      link: "/service-areas/burnside"
    },
    {
      name: "Burnside Heights",
      description: "Premium detailing services in Burnside Heights. Ceramic coating and paint protection specialists.",
      link: "/service-areas/burnside-heights"
    },
    {
      name: "St Albans",
      description: "Professional car detailing in St Albans. Mobile service with showroom-quality results.",
      link: "/service-areas/st-albans"
    },
    {
      name: "Kings Park",
      description: "Expert mobile detailing in Kings Park. Full interior & exterior packages available.",
      link: "/service-areas/kings-park"
    },
    {
      name: "Kealba",
      description: "Quality car detailing in Kealba. Professional mobile service at competitive prices.",
      link: "/service-areas/kealba"
    },
    {
      name: "Albion",
      description: "Mobile car detailing specialists in Albion. We bring the car wash to you.",
      link: "/service-areas/albion"
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('service-area-contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Helmet>
        <title>Service Areas - Mobile Car Detailing Melbourne | Starlight Motors</title>
        <meta name="description" content="Starlight Motors provides professional mobile car detailing across Melbourne's western suburbs. Find your area: Hillside, Taylors Hill, Caroline Springs, Sydenham, and more. Call 0491121950 to book." />
        <meta name="keywords" content="mobile car detailing Melbourne, service areas, western suburbs car detailing, mobile detailing locations" />
        <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://starlightmotors.com.au'}/service-areas`} />
        <meta property="og:title" content="Service Areas - Mobile Car Detailing Melbourne | Starlight Motors" />
        <meta property="og:description" content="Professional mobile car detailing across Melbourne's western suburbs. Find your area and book today." />
        <meta property="og:url" content={`${import.meta.env.VITE_SITE_URL || 'https://starlightmotors.com.au'}/service-areas`} />
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PTMBTSXR');`}
        </script>
      </Helmet>
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <section className="relative py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
            <div className="relative max-w-7xl mx-auto px-6 text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                <strong>Mobile Car Detailing Service Areas</strong>
              </h1>
              <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto mb-8">
                Professional mobile car detailing across Melbourne's western suburbs. We bring showroom-quality service directly to your location.
              </p>
              <Button onClick={scrollToContact} size="lg" className="text-lg px-8">
                Get Free Quote
              </Button>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  <strong>Areas We Service</strong>
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  Starlight Motors provides premium mobile car detailing services throughout Melbourne's western suburbs. Click on your suburb to learn more about our services in your area.
                </p>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
                {serviceAreas.map((area, index) => (
                  <a
                    key={index}
                    href={area.link}
                    className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-blue-600 hover:shadow-xl transition-all duration-300 cursor-pointer"
                  >
                    <div className="flex items-start justify-between mb-3">
                      <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                        <strong>{area.name}</strong>
                      </h3>
                      <i className="ri-arrow-right-line text-gray-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all text-xl"></i>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {area.description}
                    </p>
                  </a>
                ))}
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 md:p-12">
                <div className="max-w-3xl mx-auto text-center">
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                    <strong>Why Choose Mobile Car Detailing?</strong>
                  </h3>
                  <div className="grid md:grid-cols-3 gap-6 mt-8">
                    <div className="bg-white rounded-xl p-6 shadow-sm">
                      <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-time-line text-white text-2xl"></i>
                      </div>
                      <h4 className="font-bold text-gray-900 mb-2"><strong>Save Time</strong></h4>
                      <p className="text-sm text-gray-600">No need to drive to a car wash. We come to your home or office.</p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-sm">
                      <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-shield-check-line text-white text-2xl"></i>
                      </div>
                      <h4 className="font-bold text-gray-900 mb-2"><strong>Professional Quality</strong></h4>
                      <p className="text-sm text-gray-600">Premium products and equipment for showroom results.</p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-sm">
                      <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-map-pin-line text-white text-2xl"></i>
                      </div>
                      <h4 className="font-bold text-gray-900 mb-2"><strong>Local Service</strong></h4>
                      <p className="text-sm text-gray-600">Trusted by residents across Melbourne's western suburbs.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="service-area-contact" className="py-16 bg-gray-50">
            <div className="max-w-4xl mx-auto px-6 text-center">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                <strong>Book Your Mobile Detailing Service</strong>
              </h3>
              <p className="text-lg text-gray-600 mb-8">
                Ready to experience professional mobile car detailing in your suburb? Contact us today for a free quote.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a 
                  href="tel:0491121950"
                  className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2 text-xl"></i>
                  Call 0491 121 950
                </a>
                <a
                  href="/#contact"
                  className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg border-2 border-blue-600 hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-line mr-2 text-xl"></i>
                  Request Quote
                </a>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ServiceAreas;
